/**
 * 从 require.context 结果中读取模块列表--业务组件
 */
export const listContextModules = (modulesFiles, order = []) => {
  const array = modulesFiles.keys().map(modulePath => {
    const value = modulesFiles(modulePath);
    return value.default;
  });
  return array.sort((a, b) => order.indexOf(a.meta.name) - order.indexOf(b.meta.name));
};